import Insight from "../insightClass";
import React from "react";
import { insight107Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight107 = new Insight(
  "13 April 2026",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight107Media[0],
    alt: "offshore wind farm",
  },
  "Global Offshore Wind Weekly (2026-04-13)",
  "",
  `The UK government has officially terminated the Contracts for Difference (CfD) agreement for the TwinHub floating offshore wind project. Located in the Celtic Sea at the Hayle Heritage site, this 32MW pilot project was hailed as a pioneer for floating wind technology in the UK. Hexicon, the developer, secured the CfD in Allocation Round 4 (AR4) at a strike price that was considered highly competitive at the time. `,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2026-04-13)</h1>
    <h2></h2>
    <p className="article-date">13 April 2026</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>

    <h3>1. UK Government Terminates CfD for TwinHub Floating Project</h3>
    <p>
      The UK government has officially terminated the Contracts for Difference
      (CfD) agreement for the TwinHub floating offshore wind project. Located in
      the Celtic Sea at the Hayle Heritage site, this 32MW pilot project was
      hailed as a pioneer for floating wind technology in the UK. Hexicon, the
      developer, secured the CfD in Allocation Round 4 (AR4) at a strike price
      that was considered highly competitive at the time. However, the project
      has faced insurmountable hurdles. The termination follows significant cost
      pressures and supply chain challenges that have plagued the wider
      industry, making the original strike price unviable under current market
      conditions. This move marks a setback for the UK's ambition to reach 5GW
      of floating offshore wind capacity by 2030, as it removes one of the few
      projects that was nearing a Final Investment Decision (FID).
    </p>
    <p>
      The industry has been watching TwinHub closely as a test case for the
      commercial viability of TwinWind dual-turbine foundations. The decision to
      terminate the CfD rather than seek a price adjustment reflects the rigid
      nature of the UK's current auction framework. It also highlights the
      widening gap between the government's decarbonisation targets and the
      economic reality facing developers who must navigate high interest rates
      and the increased cost of raw materials.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      The cancellation of TwinHub’s CfD is a sobering reminder of the
      "inflationary trap" facing early-stage floating wind. While the UK remains
      a global leader in floating wind ambition, the gap between auction strike
      prices and actual Levelised Cost of Energy (LCOE) is widening. For 32MW
      projects, the economies of scale simply do not exist to absorb the 30% to
      40% increase in supply chain costs seen since 2022. This development
      underscores the urgent need for the UK government to adjust its AR7
      parameters to better reflect the specific risk profiles of nascent
      technologies like floating foundations. 
    </p>
    <p>
      WeBridge believes that without a dedicated "floating wind pot" with
      realistic price caps, more developers may follow Hexicon’s lead in handing
      back contracts, potentially jeopardising the UK’s lead in the Celtic Sea
      and beyond.
    </p>
    <h3>2. Dutch Government Expands 2026 Offshore Wind Tender</h3>
    <p>
      The Netherlands has announced the addition of a second site to its
      upcoming 2026 offshore wind tender. This move is part of the Dutch
      government’s aggressive roadmap to reach 21GW of offshore capacity by 2030
      and 70GW by 2050. The tender will now include larger zones within the
      IJmuiden Ver and Nederwiek regions, focusing on high-density energy
      production and system integration. This expansion comes after the
      Netherlands Enterprise Agency (RVO) conducted updated ecological and
      technical assessments, concluding that the North Sea could accommodate
      higher turbine density if managed correctly. The 2026 tender is expected
      to be one of the largest in Europe, attracting major global utilities and
      energy majors.
    </p>
    <p>
      A key feature of this expanded tender is the focus on "circularity" and
      "system integration." The Dutch government is pushing for offshore wind
      farms that do more than just generate electrons; they are looking for
      projects that can integrate with green hydrogen production and include
      innovative ecological measures to protect North Sea biodiversity. This
      second site addition signals to the market that the Netherlands is
      maintaining its momentum despite the macroeconomic headwinds slowing down
      projects in other European jurisdictions.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      The Dutch "centralised" model continues to be the gold standard for
      de-risking offshore wind. By handling the site investigations and
      permitting upfront and then expanding the 2026 tender, the Netherlands is
      providing the long-term visibility that developers and Tier 1 suppliers
      crave. 
    </p>
    <p>
      WeBridge notes that the emphasis on "non-price criteria"—such as grid
      stability and biodiversity—will likely favour experienced European
      consortiums capable of delivering complex, integrated energy hubs. This
      approach mitigates the "race to the bottom" on price, ensuring that the
      winners are those who can provide the most resilient energy solutions. For
      offshore wind consultancies, the Dutch market represents the most stable
      pipeline in the North Sea for the next five years.
    </p>
    <h3>
      3. Van Oord Completes ‘Industry’s First’ Silent Installation at HKW VI
    </h3>
    <p>
      Van Oord has successfully installed all 52 monopiles at the Hollandse Kust
      West(HKW) Site VI, marking a significant technical milestone. Developed by
      Ecowende(a Shell, Eneco, and Chubu Electric Power joint venture), the
      project saw the first commercial-scale deployment of "silent installation"
      technology. Using the vessel Boreas, three monopiles were installed using
      GBM Works’ VibroJet technology combined with CAPE Holland’s vibro lifting
      tool. This method uses vibrations and controlled water jetting to fluidise
      the soil, significantly reducing underwater noise levels compared to
      traditional hammer piling.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      The success at HKW VI is a game-changer for environmental permitting.
      Noise mitigation is a primary bottleneck in North Sea development due to
      strict regulations protecting marine mammals. By proving that VibroJet
      technology can perform in the challenging dense sands of the Dutch sector,
      Van Oord has provided a roadmap for "silent" construction. WeBridge
      expects this technology to become a baseline requirement for
      "ecological-first" wind farms, potentially reducing the need for expensive
      bubble curtains and allowing for construction windows that were previously
      restricted due to noise concerns.
    </p>
    <h3>4. Ørsted CEO Calls for European Supply Chain Boost</h3>
    <p>
      Mads Nipper, CEO of Ørsted, has issued a public call for European
      policymakers to provide more robust support for the regional supply chain.
      Citing the ongoing "energy crunch" and the threat of global competition,
      Nipper argued that without targeted subsidies or local content incentives,
      Europe risks losing its industrial edge in offshore wind. He emphasized
      that the speed of the energy transition is currently limited by
      manufacturing capacity rather than developer appetite. Ørsted, which has
      recently undergone a strategic review to focus on its core markets,
      remains the world’s largest offshore wind developer, but even it is
      feeling the strain of a fractured supply chain.
    </p>
    <p>
      Nipper’s comments come at a time when European manufacturers of towers,
      foundations, and cables are facing intense competition from lower-cost
      producers outside the EU. He called for a more "holistic" approach to
      offshore wind auctions that rewards local value creation and supply chain
      resilience. He also warned that the current "price-only" auction models
      are unsustainable for an industry that requires billions of euros in
      upfront capital investment.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Ørsted’s stance reflects a broader industry anxiety regarding the
      "bottleneck" effect. While project pipelines are record-sized, the
      European supply chain is struggling with thin margins and high debt.
      WeBridge believes that "supply chain sovereignty" will be a dominant theme
      in 2026, likely leading to more protectionist measures or direct state aid
      for domestic nacelle and cable manufacturing. The challenge for the EU
      will be balancing the need for cheap energy with the desire to maintain a
      domestic industrial base. WeBridge advises clients to prepare for more
      stringent "Local Content Requirements" (LCRs) in upcoming European
      tenders, as governments look to turn the energy transition into a jobs
      engine.
    </p>
    <h3>5. Jan De Nul Launches Second Next-Gen Cable Layer</h3>
    <p>
      {" "}
      Jan De Nul has launched the Fleeming Jenkin, its second ultra-large
      cable-laying vessel. This "giant" is designed to handle the massive cables
      required for high-voltage direct current (HVDC) connections and deeper
      water projects. It features advanced tensioning systems and a
      significantly higher carrying capacity than current industry standards—it
      can carry up to 28,000 tonnes of cable. This allows for longer continuous
      cable runs, which reduces the number of offshore joints required. Offshore
      joints are often the weakest point in a subsea cable system, so reducing
      them significantly improves grid reliability.
    </p>
    <p>
      The vessel is also equipped with a dual-fuel engine capable of running on
      methanol, reflecting the maritime industry's move toward decarbonisation.
      As offshore wind farms move further from shore and into deeper waters, the
      complexity of the electrical infrastructure increases. Vessels like the
      Fleeming Jenkin are essential for connecting large-scale offshore hubs to
      the mainland grid, especially for cross-border "interconnector" projects.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      The vessel shortage is one of the most acute risks to global 2030 targets.
      By investing in specialised HVDC tonnage, Jan De Nul is positioning itself
      for the "supergrid" era. WeBridge views this as a strategic bet on
      long-distance interconnection projects, which are essential for balancing
      intermittent offshore wind power across borders. There is currently a
      massive under-supply of DP3-rated cable layers, and having this capacity
      "in-house" gives Jan De Nul a major competitive advantage in securing Tier
      1 installation contracts. For developers, securing vessel slots is now as
      critical as securing permits, and we expect to see more long-term charter
      agreements being signed to hedge against vessel scarcity.
    </p>
    <h3>6. Financing Secured for 390MW Shinan Ui Project in South Korea</h3>
    <p>
      The 390MW Shinan Ui offshore wind project in South Korea has reached
      financial close, securing the necessary capital to move into the
      construction phase. This represents a major win for the South Korean
      market, which has historically struggled with permitting delays, grid
      connection issues, and local fishery opposition. The project is being
      developed by a consortium including Hanwha Corporation and is located off
      the coast of Shinan County. It is backed by a mix of domestic and
      international lenders, signaling growing investor confidence in the APAC
      region's offshore wind potential outside of the established markets of
      China and Taiwan.
    </p>
    <p>
      South Korea has set an ambitious target of 14.3GW of offshore wind by
      2030. The successful financing of Shinan Ui is seen as a "pathfinder" for
      other large-scale projects in the pipeline. The project will use 10MW+
      turbines and is expected to contribute significantly to the regional
      economy through the creation of local jobs in maintenance and operations.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      The Shinan Ui financial close is a "proof of concept" for South Korea’s
      revamped offshore wind regulations. It demonstrates that international
      capital is ready to flow into APAC markets provided there is a clear Power
      Purchase Agreement (PPA) structure and government support for grid
      integration. WeBridge expects South Korea to become a key hub for regional
      floating wind expertise as deeper sites enter the development phase.
      However, challenges remain regarding the "Jones Act-style" local vessel
      requirements and the speed of grid expansion. For international
      consultancies, the South Korean market offers significant opportunities
      for technical advisory, particularly in helping local developers meet
      international bankability standards.
    </p>
    <h3>7. World’s First Recyclable Blade Installation Offshore Denmark</h3>
    <p>
      In a parallel development to the RWE Thor project, the first Siemens
      Gamesa "RecyclableBlade" has been installed in Danish waters at the
      Kaskasi offshore wind farm. This technology allows the composite materials
      used in blades—historically destined for landfill—to be separated and
      reused in other industries at the end of the turbine's lifecycle. The
      recycling process involves a mild acidic solution that dissolves the
      resin, leaving the glass and carbon fibers intact for reuse in products
      like suitcases or flat-screen casings.
    </p>
    <p>
      This installation is part of a broader industry push toward "zero-waste
      turbines." Siemens Gamesa has committed to making all its blades fully
      recyclable by 2030 and its entire turbine recyclable by 2040. As the first
      generation of offshore wind farms reaches the end of its life, the
      industry is under increasing pressure to demonstrate that it can handle
      the decommissioning phase sustainably.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      The standardisation of recyclable components is the "final frontier" of
      wind industry sustainability. WeBridge highlights that the primary
      challenge now is not the chemistry of recycling, but the logistics of the
      secondary market. For this to be commercially viable, we need a
      cross-industry infrastructure that can actually process these materials at
      scale in 20 years' time. Developers who invest in this technology today
      are not just doing it for the environment; they are future-proofing their
      assets against potential "end-of-life" disposal taxes. WeBridge expects to
      see more collaboration between wind OEMs and the chemical industry to
      create these circular loops.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
